import { ChevronDown, ChevronUp, Check } from "lucide-react";
import { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const entriesOptions = [
  { value: 5, label: "5" },
  { value: 10, label: "10" },
  { value: 25, label: "25" },
  { value: 50, label: "50" },
  { value: 100, label: "100" },
];

const DropdownSelect = ({ selected, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleOptionClick = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    const handleScroll = () => setIsOpen(false);

    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", handleScroll, true);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, []);

  return (
    <div className="flex items-center mb-6 mt-6">
      <label className="text-black text-base font-medium">Show</label>

      <div className="relative ml-3 w-24 z-10" ref={dropdownRef}>
        <button
          onClick={toggleDropdown}
          className={`flex items-center justify-between w-full h-8 px-3 py-1 text-sm bg-transparent border border-gray-300 rounded-lg hover:border-gray-500 focus:outline-none ${
            isOpen ? "border-gray-500" : ""
          }`}
        >
          <span className="text-gray-700">{selected.label}</span>
          {isOpen ? (
            <ChevronUp className="w-4 h-4 text-gray-500" />
          ) : (
            <ChevronDown className="w-4 h-4 text-gray-500" />
          )}
        </button>

        <AnimatePresence>
          {isOpen && (
            <motion.div
              key="dropdown"
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.2 }}
              className="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg"
            >
              <ul className="py-1 max-h-60 overflow-auto">
                {entriesOptions.map((option) => (
                  <li
                    key={option.value}
                    onClick={() => handleOptionClick(option)}
                    className={`flex items-center justify-between px-3 py-2 text-sm cursor-pointer ${
                      option.value === selected.value
                        ? "bg-indigo-600 text-white"
                        : "hover:bg-gray-100 text-gray-700"
                    }`}
                  >
                    <span>{option.label}</span>
                    {option.value === selected.value && (
                      <Check className="w-4 h-4" />
                    )}
                  </li>
                ))}
              </ul>
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      <label className="text-black text-base font-medium ml-3">entries</label>
    </div>
  );
};

export default DropdownSelect;
